// extracted by extract-css-chunks-webpack-plugin
module.exports = {"OfflineBanner_container":"OfflineBanner_container_LdWit_v16-5-1","OfflineBanner_text":"OfflineBanner_text_2T5a1_v16-5-1"};